import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "contact");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Contact | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="contact-container">
						<div className="title contact-title">
							Let's Get in Touch
						</div>

						<div className="subtitle contact-subtitle">
							Thanks for taking the time to check out my work.
							If you’d like to talk about a project, collaboration,
							or just have a question, feel free to reach out. 
							You can contact me directly via email at
							&nbsp;{""}
							<a href={`mailto:${INFO.main.email}`}>{INFO.main.email}</a>
							, and I'll get back to you as soon as possible. 
							You can also fin me on the platforms below, where
							I share projects and updates related to game and
							software development. 
							I'm always open to opportunities, ideas, and conversations.
						</div>
					</div>

					<a
						href="./CV - DiegoRuizGil.pdf"
						download
						className="cv-button"
					>
						<FontAwesomeIcon icon={faFilePdf} style={{ marginRight: "0.5rem" }} />
						Download CV
					</a>

					<div className="socials-container">
						<div className="contact-socials">
							<Socials />
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
